import { render, staticRenderFns } from "./formMix.vue?vue&type=template&id=46f2a0fe&scoped=true&"
import script from "./formMix.vue?vue&type=script&lang=js&"
export * from "./formMix.vue?vue&type=script&lang=js&"
import style0 from "./formMix.vue?vue&type=style&index=0&id=46f2a0fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2a0fe",
  null
  
)

export default component.exports